/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { JSX, useEffect, useState } from 'react';
import { ExpandableRow } from '@components';
import { Field, useFormikContext } from 'formik';
import { iFVSFormValues } from '@services/FVSService';
import { iFVSCheckboxAll, iObligation } from '../../interfaces/interfaces';
import styles from './ExpandableTable.module.scss';

interface iProp {
  obligations: iObligation[];
}
const ExpandableTable = ({ obligations }: iProp): JSX.Element => {
  const { values }: { values: iFVSFormValues } = useFormikContext();
  const formikContext = useFormikContext();
  const { SelectedObligationsStep9 }: {SelectedObligationsStep9: iFVSCheckboxAll[] } = values;
  const [selectedAll, setSelectedAll] = useState(false);
    const checkboxAllInit = new Array<iFVSCheckboxAll>();
    obligations.forEach((v) => {
      checkboxAllInit.push({ number: v.Number, checked: false });
    });
    const checkboxAllTrue = new Array<iFVSCheckboxAll>();
        checkboxAllInit.forEach((v) => {
          checkboxAllTrue.push({ number: v.number, checked: true });
        });
    const [allCheckedOrNot, setCheckedAll] = useState(SelectedObligationsStep9 || checkboxAllInit);
    const handleCheckedAll = (isChecked:boolean) => {
      if (isChecked) {
        setCheckedAll(checkboxAllTrue);
      } else {
        setCheckedAll(checkboxAllInit);
      }
    };
  useEffect(() => {
    if (allCheckedOrNot?.length !== 0) {
      formikContext.setFieldValue('SelectedObligationsStep9', allCheckedOrNot);
      const checkedObs = allCheckedOrNot.reduce((accumulate, val) => {
        const checkedOb = accumulate + (val.checked ? `${val.number}, ` : '');
        return checkedOb;
      }, '').slice(0, -2);
      if (allCheckedOrNot.length === checkedObs.split(',').length) {
        setSelectedAll(true);
      } else {
        setSelectedAll(false);
      }
      if (checkedObs) {
        formikContext.setFieldValue('SelectedObNums', checkedObs);
      }
    }
  }, [allCheckedOrNot, SelectedObligationsStep9]);

  return (
    <div className={styles.offenceDetails}>
      <div className={styles.detailHeadings}>
        <span>OBLIGATION NUMBER</span>
        <span>OFFENCE DATE</span>
        <span>OFFENCE DESCRIPTION</span>
        <span>AMOUNT</span>
        <span>{' '}</span>
      </div>
      { (obligations.map((v) => <ExpandableRow key={v.Number} obligation={v} setCheckBox={setCheckedAll} checkedAllParent={allCheckedOrNot?.length !== 0 ? allCheckedOrNot : checkboxAllInit} />))}
      <div className={styles.detailValues}>
        <div className={styles.checkBoxContainer}>
          <label className={styles.inputContainer}>
            <input
              type="checkbox"
              id="checkAll"
              checked={selectedAll}
              onChange={(e) => handleCheckedAll(e.target.checked)}
          />
            <span className={styles.inputBody}>Select all / De-select all</span>
            <span className={styles.tickContainer} />
          </label>
        </div>
      </div>
      <Field name="SelectedObligationsStep9" type="hidden" />
    </div>
  );
};
export default ExpandableTable;
